/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { createContext, type ForwardedRef, forwardRef, type ReactElement } from 'react';
import { type ContextValue, ListBox as ListBoxCore, type ListBoxProps as ListBoxCoreProps, useContextProps } from 'react-aria-components';

interface ListBoxProps<T> extends Omit<ListBoxCoreProps<T>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const ListBoxContext = createContext<ContextValue<ListBoxProps<object>, HTMLDivElement>>({});

const ListBox = forwardRef((props: ListBoxProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, ListBoxContext);

  const { style, children, ...coreProps } = props;

  return (
    <ListBoxCore
      ref={ref}
      {...stylex.props(styles.base, style)}
      {...coreProps}>
      {children}
    </ListBoxCore>
  );
}) as <T>(p: ListBoxProps<T> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    outline: 'none',
    overflow: 'auto',
    boxSizing: 'border-box',
    maxHeight: 'inherit',
  },
});

export { ListBox, ListBoxContext, type ListBoxProps };
